import { render, staticRenderFns } from "./DirectusArticle.vue?vue&type=template&id=28d0c325&scoped=true&"
import script from "./DirectusArticle.vue?vue&type=script&lang=js&"
export * from "./DirectusArticle.vue?vue&type=script&lang=js&"
import style0 from "./DirectusArticle.vue?vue&type=style&index=0&id=28d0c325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0c325",
  null
  
)

export default component.exports